// export const locationHost = process.env.NODE_ENV === 'production' ? "http://shop.chinalutian.com/" : 'http://localhost:8080';
export const locationHost = process.env.NODE_ENV === 'production' ? "https://www.haibaoguoji.com/" : 'http://localhost:8080';
//export const locationHost = process.env.NODE_ENV === 'production' ? "https://hbsw.jihainet.com/" : 'http://localhost:8080';

// export const apiBaseUrl = 'https://b2c.jihainet.com/';
// export const apiBaseUrl = 'http://n.haibaoguoji.com/';
export const apiBaseUrl = 'https://www.haibaoguoji.com/';
// export const apiBaseUrl = 'http://www.haibao.com/';
// export const apiBaseUrl = 'http://www.cloud.com/';
// export const apiBaseUrl = 'http://b2c.cn/';
//export const apiBaseUrl = 'https://hbsw.jihainet.com/';



